module.exports = __webpack_public_path__ + "media/bootstrap-icons/at-02b929bf.svg";